import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import db from './db';
var functions = require("./functions.js");
// SubmersionTable component
export default class SubmersionTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);

        // initalize state
        this.state = {
            submersions:[]
        }
        this.inputRef = React.createRef();
    }
    componentDidMount() {
        this.inputRef.current.focus();
    }
    inputFilterKeyUp(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          this.querySubmersions();
        }
    }    
    // render
    render() {

        return (
            <div>
                <div>
                    Host Name:<input id="hostname" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} ref={this.inputRef}/>&nbsp;
                    Limit:<input id="limit" defaultValue="100" type="number" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)}/>&nbsp;
                    <button onClick={()=>{this.querySubmersions()}} >Query Submersions</button>&nbsp;
                </div>
                <TableScrollbar height="80vh"r>
                    <ErrorBoundary>
                        <Table columns={[
                                    { key: 'type', title:"type", width :10 } 
                                    , { key: 'start_event_date', title:"event date", width :10, render:functions.renderDateInTable }
                                    , { key: 'hostname', title:"hostname", width :10 }
                                    , { key: 'reason', title:"reason", width :10 }
                                    , { key: 'headset_id', title:"headset id", width :10 }
                                    , { key: 'diff_in_seconds', title:"duration(seconds)", width :10 }
                                ]} 
                                dataSource={this.state.submersions} 
                                />
                    </ErrorBoundary>
                </TableScrollbar>
            </div>
        );
    }

    // load the table
    querySubmersions(params){
        db.getSubmersions( 
            document.getElementById("hostname").value
            ,document.getElementById("limit").value
            ,this.props.securityObject
            ,(submersionList) => { 
                this.setState({
                    submersions : submersionList
                })
            }
            ,params
        )
    }

}